
/*
 * 문서 분석 설정을 보관하기 위한 데이터 클래스
 */
const AnalysisConfig = class {
    constructor(tokenizer, section, limit, split, posList, password) {
        this.tokenizer = tokenizer
        this.section = section
        this.limit = limit
        this.split = split
        this.posList = posList
        this.password = password
    }
    json() {
        const {tokenizer, section, limit, split, posList, password} = this
        const result = {tokenizer, section, limit, split, pos: posList ? posList.join(',') : null, password}
        Object.keys(result).forEach(key => result[key] === undefined || result[key] === null ? delete result[key] : {})
        return result
    }
}

module.exports = AnalysisConfig
